import AlertBar from './AlertBar';

export default AlertBar;



// WEBPACK FOOTER //
// ./src/views/components/Common/AlertBar/index.js